import { render } from "./RecentJobsTable.vue?vue&type=template&id=693216a6"
import script from "./RecentJobsTable.vue?vue&type=script&lang=js"
export * from "./RecentJobsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__